import { cn } from "@/lib/utils";
import { Snowflake, Wind } from "lucide-react";

export const SNOWFALL_TOTALS_OPTIONS = [
  { value: "0-3cm", label: "0–3 cm", color: "#B0B0B0" },
  { value: "1-5cm", label: "1–5 cm", color: "#A3DFFF" },
  { value: "5-10cm", label: "5–10 cm", color: "#3B82F6" },
  { value: "10-15cm", label: "10–15 cm", color: "#1E40AF" },
  { value: "15-20cm", label: "15–20 cm", color: "#EC4899" },
  { value: ">20cm", label: ">20 cm", color: "#9333EA" },
];

export const SEVERE_PHENOMENA_OPTIONS = [
  { value: "Blizzards", label: "Blizzards", color: "#F97316" },
  { value: "Snow Melt", label: "Snow Melt", color: "#3B82F6" },
  { value: "Freezing Rain", label: "Freezing Rain", color: "#8B5CF6" },
];

export function SnowfallTotals({ totals = [], className }) {
  const active = SNOWFALL_TOTALS_OPTIONS.filter((o) => totals.includes(o.value));
  if (active.length === 0) return null;

  return (
    <div className={cn("space-y-3", className)} data-testid="snowfall-totals">
      <h4 className="font-heading text-xs uppercase tracking-widest text-[#6B7280] flex items-center gap-2">
        <Snowflake className="w-4 h-4 text-[#7DD3FC]" />
        Snowfall Totals
      </h4>
      <div className="flex flex-wrap gap-1.5">
        {active.map((opt) => (
          <span
            key={opt.value}
            className="px-2.5 py-1 text-[10px] uppercase tracking-wider font-semibold border"
            style={{
              color: opt.color,
              borderColor: `${opt.color}60`,
              backgroundColor: `${opt.color}15`,
            }}
            data-testid={`snowfall-badge-${opt.value}`}
          >
            {opt.label}
          </span>
        ))}
      </div>
    </div>
  );
}

export function SeverePhenomena({ phenomena = [], className }) {
  const active = SEVERE_PHENOMENA_OPTIONS.filter((o) => phenomena.includes(o.value));
  if (active.length === 0) return null;

  return (
    <div className={cn("space-y-3", className)} data-testid="severe-phenomena">
      <h4 className="font-heading text-xs uppercase tracking-widest text-[#6B7280] flex items-center gap-2">
        <Wind className="w-4 h-4 text-[#F97316]" />
        Severe Phenomena
      </h4>
      <div className="flex flex-wrap gap-1.5">
        {active.map((opt) => (
          <span
            key={opt.value}
            className="px-2.5 py-1 text-[10px] uppercase tracking-wider font-semibold border"
            style={{
              color: opt.color,
              borderColor: `${opt.color}60`,
              backgroundColor: `${opt.color}15`,
            }}
            data-testid={`phenomena-badge-${opt.value}`}
          >
            {opt.label}
          </span>
        ))}
      </div>
    </div>
  );
}

// Compact badges for archive cards
export function SnowfallBadges({ outlook, className }) {
  const totals = Array.isArray(outlook.snowfall_totals) ? outlook.snowfall_totals : [];
  const phenomena = Array.isArray(outlook.severe_phenomena) ? outlook.severe_phenomena : [];
  if (totals.length === 0 && phenomena.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap gap-1", className)} data-testid="snowfall-badges">
      {totals.map((val) => {
        const opt = SNOWFALL_TOTALS_OPTIONS.find((o) => o.value === val);
        if (!opt) return null;
        return (
          <span
            key={val}
            className="px-2 py-0.5 text-[9px] uppercase tracking-wider font-medium border"
            style={{
              color: opt.color,
              borderColor: `${opt.color}50`,
              backgroundColor: `${opt.color}10`,
            }}
          >
            {opt.label}
          </span>
        );
      })}
      {phenomena.map((val) => {
        const opt = SEVERE_PHENOMENA_OPTIONS.find((o) => o.value === val);
        if (!opt) return null;
        return (
          <span
            key={val}
            className="px-2 py-0.5 text-[9px] uppercase tracking-wider font-medium border"
            style={{
              color: opt.color,
              borderColor: `${opt.color}50`,
              backgroundColor: `${opt.color}10`,
            }}
          >
            {opt.label}
          </span>
        );
      })}
    </div>
  );
}
